"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2280],{

/***/ 2280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ iframe_IFrame; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/base/iframe/IFrame.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var IFrame = function(props, ref) {
    if (props.children) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "iframe",
            ref: ref,
            tabIndex: -1,
            src: String(props.children)
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", _objectSpread({
            title: "iframe",
            ref: ref,
            tabIndex: -1
        }, props)));
    }
};
/* harmony default export */ var iframe_IFrame = (/*#__PURE__*/react.forwardRef(IFrame));

;// CONCATENATED MODULE: ./components/base/iframe/index.tsx



/***/ })

}]);